export default __webpack_public_path__ + "static/media/ag.0263bb55.svg";